import AbstractStorage from './abstract-storage';
import CookieStorage from './cookie-storage';

module.exports = () => {
  let storageClass = AbstractStorage;
  let hasGlobalStorage = true;

  // Check if global storage is available
  try {
    if (window.sessionStorage) {
      // Necessary check for Safari iOS who throws error on sessionStorage.setItem() when in private browsing mode
      window.sessionStorage.setItem('test', ' ');
      window.sessionStorage.removeItem('test');
    } else {
      hasGlobalStorage = false;
    }
  } catch (error) {
    hasGlobalStorage = false;
  }

  if (!hasGlobalStorage) {
    storageClass = CookieStorage;
  }

  class SessionStorage extends storageClass {
    name() {
      return 'sessionStorage';
    }
  }

  return class SessionStorageProvider {
    static $get = ['$cookies', '$window', ($cookies, $window) => {
      if (hasGlobalStorage) {
        return new SessionStorage($window);
      }
      return new SessionStorage($cookies, $window);
    }];
  };
};



// WEBPACK FOOTER //
// ./main/providers/session-storage.js